import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import BarreMobile from './components/BarreMobile';
import BandeauCookies from './components/BandeauCookies';
import HautDePage from './components/HautDePage';

import Accueil from './pages/Accueil';
import NosEngins from './pages/NosEngins';
import FicheMachine from './pages/FicheMachine';
import SansChauffeur from './pages/SansChauffeur';
import Livraison from './pages/Livraison';
import PageCommune from './pages/PageCommune';
import Entreprise from './pages/Entreprise';
import Contact from './pages/Contact';
import PageFaq from './pages/PageFaq';
import GestionAvis from './pages/GestionAvis';
import { MentionsLegales, Confidentialite, Cookies, ChartAvis } from './pages/Legal';
import PageIntrouvable from './pages/PageIntrouvable';
import { COMMUNES_PAGES } from './data/site';

export default function App() {
  return (
    <>
      <a
        href="#contenu"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:top-2 focus:left-2 focus:bg-jaune focus:text-nuit focus:px-4 focus:py-2 focus:font-cond focus:uppercase"
      >
        Aller au contenu
      </a>
      <HautDePage />
      <Header />
      <main id="contenu">
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/nos-engins" element={<NosEngins />} />
          <Route path="/nos-engins/:slug" element={<FicheMachine />} />
          <Route path="/location-sans-chauffeur" element={<SansChauffeur />} />
          <Route path="/livraison-ile-de-france" element={<Livraison />} />
          {COMMUNES_PAGES.map((c) => (
            <Route
              key={c.slug}
              path={`/location-engins-chantier-${c.slug}`}
              element={<PageCommune commune={c} />}
            />
          ))}
          <Route path="/entreprise" element={<Entreprise />} />
          <Route path="/faq" element={<PageFaq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/charte-avis" element={<ChartAvis />} />
          <Route path="/gestion-avis" element={<GestionAvis />} />
          <Route path="*" element={<PageIntrouvable />} />
        </Routes>
      </main>
      <Footer />
      <BarreMobile />
      <BandeauCookies />
    </>
  );
}
